import React, { useState, useEffect, useRef } from "react";
import "../styles/accordnew.css";
import HistoryModel from "../component/HistoryModal";
import { fetchDisableEnablebetbuilder } from "../api/api";
import SubAccordion from "./SubAccordionNew";
import { formatValue } from "../helper/index";

const Accordion = ({
  data,
  allMarketCategoriesData,
  handleCloseModal,
  handleOpenModal,
  showHistory,
  handleShowComplementaryStat,
  expandedrtb,
  matchId,
  oddsFormat,
  activeButton,
  activeMarketName,
  language
}) => {
  const subAccordionRef = useRef(null);
  const [expandedItems, setExpandedItems] = useState([]);
  const [enabledMarkets, setEnabledMarkets] = useState([]);
  const [disabledMarkets, setDisabledMarkets] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [selectedMarketsuniqueKey, setSelectedMarketsuniqueKey] = useState([]);
  const [selectedMarkets, setSelectedMarkets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [shouldScroll, setShouldScroll] = useState(false);
  const [allExpanded, setAllExpanded] = useState(false);
  const [complementary, setComplementary] = useState(false);


  const isDisabled = (uniqueKey) => disabledMarkets.includes(uniqueKey);
  const isSelected = (uniqueKey) =>
    selectedMarketsuniqueKey.includes(uniqueKey);
  const modifyWinLossStatus = (val) => (val ? val.split(",") : []);

  const SelectedData = allMarketCategoriesData.filter((item) =>
    selectedMarketsuniqueKey.includes(item.uniqueKey)
  );

  const handleCardClick = async (matchid, uniqueKey, index, marketId) => {
    if (isDisabled(marketId)) return;
    setLoading(true);
    setShouldScroll(true);
    const updatedUniqueKeys = [
      ...new Set([...selectedMarketsuniqueKey, uniqueKey]),
    ];
    setSelectedMarketsuniqueKey(updatedUniqueKeys);

    const updatedMarket = [...new Set([...selectedMarkets, marketId])];
    setSelectedMarkets(updatedMarket);

    try {
      const response = await fetchDisableEnablebetbuilder(
        1,
        language,
        5,
        matchid,
        updatedUniqueKeys.join(",")
      );
      const result = response?.data;
      setEnabledMarkets(result?.enablemarkets || []);
      setDisabledMarkets(result?.disablemarkets || []);
      setIsFilterApplied(true);
    } catch (error) {
      console.error("Error fetching Bet Builder data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setEnabledMarkets([]);
    setDisabledMarkets([]);
    setSelectedMarketsuniqueKey([]);
    setIsFilterApplied(false);
  }, [matchId]);

  const finalData = isFilterApplied
    ? data.filter(
        (item) =>
          selectedMarketsuniqueKey.includes(item.uniqueKey) ||
          enabledMarkets.includes(item.uniqueKey) ||
          disabledMarkets.includes(item.uniqueKey)
      )
    : data;

  useEffect(() => {
    if (shouldScroll && subAccordionRef.current && finalData) {
      subAccordionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      setShouldScroll(false);
    }
  }, [shouldScroll, SelectedData, finalData]);

  const handleBetBuilderClose = async (uniqueKey) => {
    setLoading(true);
    const updatedUniqueKeys = selectedMarketsuniqueKey.filter(
      (key) => key !== uniqueKey
    );
    setSelectedMarketsuniqueKey(updatedUniqueKeys);

    const marketToRemove = allMarketCategoriesData.find(
      (item) => item.uniqueKey === uniqueKey
    )?.marketid;
    const updatedMarkets = selectedMarkets.filter(
      (marketId) => marketId !== marketToRemove
    );
    setSelectedMarkets(updatedMarkets);

    try {
      if (updatedUniqueKeys.length > 0) {
        const response = await fetchDisableEnablebetbuilder(
          1,
          language,
          5,
          matchId,
          updatedUniqueKeys.join(",")
        );
        const result = response?.data;
        setEnabledMarkets(result?.enablemarkets || []);
        setDisabledMarkets(result?.disablemarkets || []);
        setIsFilterApplied(true);
      } else {
        setEnabledMarkets([]);
        setDisabledMarkets([]);
        setIsFilterApplied(false);
        setSelectedMarketsuniqueKey([]);
      }
    } catch (error) {
      console.error("Error updating Bet Builder data:", error);
    } finally {
      setLoading(false);
    }
  };

  const toggleAllExpanded = () => {
    if (allExpanded) {
      setExpandedItems([]);
    } else {
      const allIndexes = finalData.map((_, i) => i);
      setExpandedItems(allIndexes);
    }
    setAllExpanded((prev) => !prev);
  };

  const toggleItemExpansion = (index) => {
    setExpandedItems((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleClearAllSelections = () => {
    setSelectedMarketsuniqueKey([]);
    setSelectedMarkets([]);
    setEnabledMarkets([]);
    setDisabledMarkets([]);
    setIsFilterApplied(false);
  };

 const groupByMarketId = (data) =>
    Object.values(
      data.reduce((acc, item) => {
        const { marketid, bestbetname } = item;
        if (!acc[marketid]) {
          acc[marketid] = {
            bestbetname,
            items: [],
          };
        }
        acc[marketid].items.push(item);
        return acc;
      }, {})
    );
  const isGrouped = activeButton === 5;
  const finalRenderData = isGrouped ? groupByMarketId(finalData) : finalData;


  return (
    <>
      <div className="accordion-wrapper">
        {loading && (
          <div className="accordion-loading-overlay">
            <div className="spinner-loading"></div>
          </div>
        )}

        <div className="accordion">
          {finalRenderData.length === 0 ? (
            <div className="AF-error-message">{activeMarketName} stats unavailable until odds are released.</div>
          ) : (
            <>
              
                <div className="expand-collapse-wrapper">
                  <button
                    onClick={toggleAllExpanded}
                    className="expand-collapse-btn"
                  >
                    {allExpanded ? "Expand All" : "Collapse All"}
                  </button>
                </div>
                {selectedMarketsuniqueKey.length > 0 &&
                  SelectedData.length > 0 &&
                  isFilterApplied && (
                    <div ref={subAccordionRef}>
                      <SubAccordion
                        data={SelectedData}
                        oddsFormat={oddsFormat}
                        handleBetBuilderClose={handleBetBuilderClose}
                        loading={loading}
                        onClearAllSelections={handleClearAllSelections}
                      />
                    </div>
                  )}
              

              {finalRenderData.map((itemOrGroup, index) => {
                const items = isGrouped ? itemOrGroup.items : [itemOrGroup];
                const headerText = isGrouped
                  ? itemOrGroup.bestbetname.split('-')[0]
                  : itemOrGroup.bestbetname;

                return (
                  <div
                    className={`accordion-item ${
                      expandedItems.includes(index) ? "expanded" : ""
                    }`}
                    key={index}
                  >
                    <button
                      className="accordion-header open"
                      onClick={() => toggleItemExpansion(index)}
                    >
                      {headerText}
                    </button>

                    <div
                      className={`accordion-content-total ${
                        expandedItems.includes(index) ? "" : "show"
                      }`}
                    >
                      
                      {items.map((item, i) => {
                        const itemIndex = isGrouped ? i : index;
                        const status = modifyWinLossStatus(item.form);
                        const status2 = modifyWinLossStatus(item.complementaryform);
                        const grading = item.grading * 10;
                        const disabled = isDisabled(item.uniqueKey);
                        const selected = isSelected(item.uniqueKey);
                        const isExpanded2 = expandedrtb === itemIndex;
                        const radius = 20;
                        const circumference = 2 * Math.PI * radius;
                        const progress = Math.max(0, Math.min(100, parseInt(grading)));
                        const offset = circumference * (1 - progress / 10);


                        return (
                          <>
                          <div
                            key={i}
                            className={`accordion-subitem ${selected ? "selected" : ""}`}
                            onClick={() =>
                              handleCardClick(
                                matchId,
                                item.uniqueKey,
                                itemIndex,
                                item.marketid
                              )
                            }
                            style={{
                              pointerEvents:disabled || selected || loading || item.odds.decimalodds === '1.01' || item.odds.decimalodds === '1.010' || item.odds.decimalodds === null || item.odds.decimalodds == 0 || item.odds.decimalodds === 1.010 ? "none": "auto",
                              opacity: disabled || item.odds.decimalodds === '1.01' || item.odds.decimalodds === '1.010' || item.odds.decimalodds === null || item.odds.decimalodds == 0 || item.odds.decimalodds === 1.010? 0.6 : 1,
                            }}
                          >
                            <div className="column rtb-status">
                              {isGrouped ? <span className="market_name">{item.market}</span> : ''}
                              <span>{item.rtb}</span>
                              <div className="win_loss_status">
                                {status.slice(0, 6).map((s, j) => (
                                  <span
                                    key={j}
                                    className={`win_loss_badge ${
                                      s === "W"
                                        ? "win"
                                        : s === "L"
                                        ? "loss"
                                        : "draw"
                                    }`}
                                     onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          handleOpenModal(item.uniqueKey);
                                          setComplementary(false)
                                        }}
                                  >
                                    {s}
                                  </span>
                                ))}
                                {item.complementaryrtb && (
                                  <span className="icon_plus_minus">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-icon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.stopPropagation();
                                        handleShowComplementaryStat(itemIndex);
                                      }}
                                    >
                                      {isExpanded2 ? (
                                        <line x1="5" y1="12" x2="19" y2="12" />
                                      ) : (
                                        <>
                                          <line
                                            x1="12"
                                            y1="5"
                                            x2="12"
                                            y2="19"
                                          />
                                          <line
                                            x1="5"
                                            y1="12"
                                            x2="19"
                                            y2="12"
                                          />
                                        </>
                                      )}
                                    </svg>
                                  </span>
                                )}
                              </div>

                              {item.complementaryrtb && isExpanded2 && (
                                <div className="column rtb-status rtb-space">
                                  {item.complementaryrtb}
                                  <div className="win_loss_status2">
                                    {status2.slice(0, 6).map((s, j) => (
                                      <span
                                        key={j}
                                        className={`win_loss_badge ${
                                          s === "W"
                                            ? "win"
                                            : s === "L"
                                            ? "loss"
                                            : "draw"
                                        }`}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          handleOpenModal(item.uniqueKey);
                                          setComplementary(true)
                                        }}

                                      >
                                        {s}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>

                            {item.odds.decimalodds === '1.01' || item.odds.decimalodds === '1.010' || item.odds.decimalodds === null || item.odds.decimalodds == 0 || item.odds.decimalodds === 1.010 ? 
                              <>
                              <div className="column lock-container-noodds">
                                {(disabled || 
                                  item.odds.decimalodds === '1.01' || 
                                  item.odds.decimalodds === '1.010' || 
                                  item.odds.decimalodds === null || 
                                  item.odds.decimalodds === 0 || 
                                  item.odds.decimalodds === 1.010) && (
                                    <span className="lock-icon">🔒</span>
                                )}
                              </div>
                              <div className="column email-error-msg">Odds currently unavailable</div>

                              </>
                              
                            :
                              <>
                              <div className="column button-container">
                                <button
                                  className="btn-accordion"
                                  disabled={disabled}
                                  style={{
                                    cursor: disabled ? "not-allowed" : "pointer",
                                  }}
                                >
                                  {oddsFormat === "EU"
                                    ? parseFloat(item.odds.decimalodds).toFixed(2)
                                    : formatValue(item.odds.americanodds)}
                                </button>
                              </div>

                              <div className="column lock-container">
                                {(disabled || 
                                  item.odds.decimalodds === '1.01' || 
                                  item.odds.decimalodds === '1.010' || 
                                  item.odds.decimalodds === null || 
                                  item.odds.decimalodds === 0 || 
                                  item.odds.decimalodds === 1.010) && (
                                    <span className="lock-icon">🔒</span>
                                )}
                              </div>

                              <div className="column progress-container">
                                <div className="tooltip-wrapper-new">
                                  <div className="circular-progress">
                                      <span className="progress-value">
                                        {parseFloat(grading.toFixed(2))}
                                      </span>
                                      <svg className="progress-circle" viewBox="0 0 50 50">
                                        <circle
                                          className="progress-bg"
                                          cx="25"
                                          cy="25"
                                          r="20"
                                        />
                                        <circle
                                          className="progress-bar"
                                          cx="25"
                                          cy="25"
                                          r="20"
                                          strokeDasharray={circumference}
                                          strokeDashoffset={offset}
                                        />
                                      </svg>
                                  </div>
                                  <span className="tooltip-text-new">
                                    Strength score (0–10) based on stat frequency & odds value. Higher = better.
                                  </span>
                                </div>
                              </div>
                              </>
                            }

                            {showHistory === item.uniqueKey && (item.history || item.complementaryhistory) && (
                              <HistoryModel
                                onClose={handleCloseModal}
                                onClick={handleOpenModal}
                                history={complementary ? item.complementaryhistory : item.history}
                                play="soccer"
                              />
                            )}
                          </div>
                          {item.marketcategoryid === 6 &&
                            <div className="more-market">More Markets Coming Soon</div>
                          }
                          </>

                        );
                        
                      })}
                      
                    </div>
                    
                  </div>
                );
              })}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Accordion;
